var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9113_6758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97644 21.4816H1.41016V20.5524C1.4216 19.4562 1.66604 18.3749 2.12727 17.3804C2.5885 16.3858 3.25596 15.5008 4.08537 14.7839C4.91477 14.067 5.88716 13.5347 6.938 13.2223C7.98884 12.9099 9.0941 12.8245 10.1804 12.9719M9.12444 9.48158C10.2611 9.48158 11.3512 9.03006 12.1549 8.22633C12.9586 7.4226 13.4102 6.33251 13.4102 5.19587C13.4102 4.05923 12.9586 2.96914 12.1549 2.16541C11.3512 1.36169 10.2611 0.910156 9.12444 0.910156C7.9878 0.910156 6.89771 1.36169 6.09398 2.16541C5.29026 2.96914 4.83873 4.05923 4.83873 5.19587C4.83873 6.33251 5.29026 7.4226 6.09398 8.22633C6.89771 9.03006 7.9878 9.48158 9.12444 9.48158ZM16.6793 12.053C16.452 12.053 16.234 12.1433 16.0732 12.3041C15.9125 12.4648 15.8222 12.6828 15.8222 12.9102V15.3222H13.4084C13.1811 15.3222 12.9631 15.4125 12.8024 15.5732C12.6416 15.734 12.5513 15.952 12.5513 16.1793V18.9633C12.5513 19.1906 12.6416 19.4086 12.8024 19.5694C12.9631 19.7301 13.1811 19.8204 13.4084 19.8204H15.8204V22.2324C15.8204 22.4598 15.9107 22.6778 16.0715 22.8385C16.2322 22.9993 16.4503 23.0896 16.6776 23.0896H19.4616C19.6889 23.0896 19.9069 22.9993 20.0677 22.8385C20.2284 22.6778 20.3187 22.4598 20.3187 22.2324V19.8222H22.7307C22.9581 19.8222 23.1761 19.7319 23.3368 19.5711C23.4976 19.4104 23.5879 19.1923 23.5879 18.965V16.1793C23.5879 15.952 23.4976 15.734 23.3368 15.5732C23.1761 15.4125 22.9581 15.3222 22.7307 15.3222H20.3204V12.9084C20.3204 12.6811 20.2301 12.4631 20.0694 12.3024C19.9086 12.1416 19.6906 12.0513 19.4633 12.0513H16.6776L16.6793 12.053Z",
    stroke: "#63382C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9113_6758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.2888c548a5e0500121cd9918976fa0d6.svg";
export { ForwardRef as ReactComponent };